import { Button, cn, Tooltip } from '@rematter/ui-web';
import { ArrowRight } from 'lucide-react';

type Props = {
  onPress: () => void;
  isDisabled?: boolean;
  className?: string;
};

export const RemainingWeightButton: React.FC<Props> = ({
  onPress,
  isDisabled = false,
  className = '',
}) => (
  <div className="@RemainingWeightButton contents">
    <Tooltip tip="Use remaining weight" wrapWithButton={false}>
      <Button
        icon={<ArrowRight />}
        color="neutral"
        onPress={onPress}
        isDisabled={isDisabled}
        variant="outline"
        className={cn(
          isDisabled &&
            'border-none bg-neutral/5 p-0 outline-none [&_*]:!opacity-100',
          'w-[40px] px-2',
          className,
        )}
      />
    </Tooltip>
  </div>
);
